import { useEffect, useRef, useState } from "react";
import "./register.scss";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Api from "../../../core/Api";
import { useCallback } from "react";
import { StorageHelpers } from "../../../core/Helpers";

const useRegister = () => {
  const refReCaptcha = useRef();
  const [isPerson, setIsPerson] = useState(true);
  const [towns, setTowns] = useState([]);
  const [district, setDistrict] = useState();
  const [ShowSmsValidatorModal, setShowSmsValidatorModal] = useState(false);
  const [dataAddress, setDataAddress] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [branchesLoading, setBranchesLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        Api.getAddressInfoAsync().then((data) => setDataAddress(data));
        setBranchesLoading(true);
        const response = await Api.getBranchesAsync();
        setBranches(response.data.data);
      } finally {
        setBranchesLoading(false);
      }
    };
    fetchData();
  }, []);

  const formik = useFormik({
    initialValues: {
      firmType: 1,
      idNo: "",
      gsm: "",
      email: "",
      title: "",
      gRecaptchaToken: null,
      relatedPerson: "",
      idCountry: 1,
      idCity: 0,
      idTown: null,
      idDistrict: null,
      address1: "",
      address2: "",
      gsmCode: "",
      isRegister: true,
      idBranch: 1,
    },
    validationSchema: Yup.object().shape({
      idNo: Yup.string()
        .required("Bu alan boş bırakılamaz.")
        .matches(/^[0-9]+$/, "Geçersiz TC / Vergi numarası girdiniz.")
        .min(10, "TC / Vergi Numarası 10 haneden düşük olamaz.")
        .max(11)
        .nullable(false),

      gsm: Yup.string().required("Bu alan boş bırakılamaz."),
      email: Yup.string().email("Hatalı e-mail adresi girdiniz."),
      title: Yup.string().required("Bu alan boş bırakılamaz."),
      relatedPerson: Yup.string(),
      idCountry: Yup.number().nullable(),
      idCity: Yup.number().nullable(),
      idTown: Yup.number().nullable(),
      address1: Yup.string(),
      idBranch: Yup.number().required("Bu alan boş bırakılamaz."),
    }),
    onSubmit: async (val) => {
      setIsLoading(true);
      const isCaptchaVerify = await StorageHelpers.isGoogleRecaptchaVerifyAsync({
        ref: refReCaptcha,
        token: val.gRecaptchaToken,
      });

      if (isCaptchaVerify) {
        val.idCity = parseInt(val.idCity);
        const response = await Api.validateAccountAsync(val);
        if (response.data.isSuccess) {
          toast.success("Yönlendiriliyorsunuz...", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setShowSmsValidatorModal(true);
          setIsLoading(false);
        } else {
          toast.error("Bilgileriniz eksik veya hatalı.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
        }
      } else {
        toast.error("Google Recaptcha güvenlik doğrulaması başarısız oldu. Lütfen tekrar deneyiniz..", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setIsLoading(false);
      }
    },
  });

  const gRecaptchaVerify = useCallback(async ({ token }) => {
    await formik.setFieldValue("gRecaptchaToken", token);
  }, []);

  const handleChange = (value) => {
    const filteredData = dataAddress.data.data[0].cities.find((x) => x.id === value);
    setTowns(filteredData.towns);
  };

  const handleTowns = (value) => {
    const filteredTowns = towns.find((x) => x.id === value);
    Api.getDistrictByCountryAsync(filteredTowns.id).then((resp) => setDistrict(resp));
  };

  const form = {
    legal: {
      onClick: () => {
        setIsPerson(false);
      },
      className: `${
        isPerson ? "bg-[#1b263b]" : "bg-[#778da9]"
      }  text-white p-2 rounded-l-md w-full text-center text-lg shadow-md cursor-pointer hover:opacity-80 px-12 duration-300`,
    },
    person: {
      onClick: () => setIsPerson(true),
      className: `${
        isPerson ? "bg-[#778da9]" : "bg-[#1b263b]"
      }  text-white p-2 rounded-r-md w-full text-lg text-center px-12  cursor-pointer shadow-md hover:opacity-80 duration-300`,
    },
    idNo: {
      type: "text",
      value: formik.values.idNo,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      placeholder: isPerson ? "TC Kimlik Numarası" : "Vergi Numarası",
      id: "idNo",
      maxLength: "11",
      className: `rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300 border-2 ${
        formik.touched.idNo && formik.errors.idNo ? "border-red-600 focus:border-red-600" : "border-gray-300"
      }`,
    },
    gsm: {
      type: "text",
      id: "gsm",
      name: "gsm",
      placeholder: "Telefon Numarası",
      value: formik.values.gsm,
      onBlur: formik.handleBlur,
      mask: "999-999-99-99",
      onChange: formik.handleChange,
      className: `rounded-md white text-base p-2 pl-4  border-2 ${
        formik.touched.gsm && formik.errors.gsm && "border-red-600"
      }`,
    },
    email: {
      value: formik.values.email,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      type: "email",
      id: "email",
      placeholder: "E-Posta Adresiniz",
      className: `rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300  border-2 ${
        formik.touched.email && formik.errors.email ? "border-red-600 focus:border-red-600" : "border-gray-300"
      }`,
    },
    title: {
      type: "text",
      value: formik.values.title,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      id: "title",
      placeholder: isPerson ? "Ad Soyad" : "Klinik Adı",
      className: `rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300  border-2 ${
        formik.touched.title && formik.errors.title ? "border-red-600 focus:border-red-600" : "border-gray-300"
      }`,
    },
    relatedPerson: {
      type: "text",
      value: formik.values.relatedPerson,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      id: "relatedPerson",
      placeholder: "Yetkili Adı",
      className: `rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300  border-2 ${
        formik.touched.relatedPerson && formik.errors.relatedPerson
          ? "border-red-600 focus:border-red-600"
          : "border-gray-300"
      }`,
    },
    idCity: {
      id: "idCity",
      onChange: (e) => {
        handleChange(parseInt(e.target.value));
        formik.setFieldValue("idCity", e.target.value);
      },
      onBlur: formik.handleBlur,
      className: `p-2 pl-4 text-base border-2 border-gray-300  focus:border-yellow-500 duration-300 rounded-md ${
        formik.touched.idCity && formik.errors.idCity ? "border-red-600 focus:border-red-600" : "border-gray-300"
      }`,
      name: "idCity",
    },
    idTown: {
      id: "idTown",
      onChange: (e) => {
        handleTowns(parseInt(e.target.value));
        formik.setFieldValue("idTown", e.target.value);
      },
      onBlur: formik.handleBlur,
      className: "p-2 pl-4 text-base border-2 border-gray-300  focus:border-yellow-500 duration-300 rounded-md",
      name: "idTown",
    },
    idDistrict: {
      value: formik.values.idDistrict,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      id: "idDistrict",
      className: "p-2 pl-4 text-base border-2 border-gray-300  focus:border-yellow-500 duration-300 rounded-md",
      name: "idDistrict",
    },
    address1: {
      value: formik.values.address1,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      id: "address1",
      type: "text",
      placeholder: "Adres 1",
      className:
        "rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300  border-2 border-gray-300",
    },
    address2: {
      value: formik.values.address2,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      id: "address2",
      type: "text",
      placeholder: "Adres 2",
      className:
        "rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300  border-2 border-gray-300",
    },
    registerButton: {
      disabled: isLoading,
      type: "submit",
      className: isLoading
        ? "bg-gray-600 text-white p-2 w-full font-semibold rounded-md hover:bg-gray-700 duration-300"
        : "bg-red-600 text-white p-2 w-full font-semibold rounded-md hover:bg-red-500 duration-300 ",
    },
    gRecaptcha: {
      onVerify: (token) => gRecaptchaVerify({ token: token }),
      ref: refReCaptcha,
    },
    idBranch: {
      onChange: (e) => formik.setFieldValue("idBranch", e.target.value),
      className:
        "rounded-md white text-base p-2 pl-4 w-full focus:border-yellow-500 duration-300 border-2 border-gray-300",
      value: formik.values.idBranch,
    },
  };

  return {
    form,
    formik,
    isPerson,
    towns,
    district,
    isLoading,
    ShowSmsValidatorModal,
    setShowSmsValidatorModal,
    dataAddress,
    branches,
    branchesLoading,
  };
};

export default useRegister;
